import { graphql } from "gatsby"
import React from "react"
import { Col, Container, Row } from "reactstrap"
import { Hero, Layout, Seo } from "../components"
import { stripTags } from "../lib/utils"
import { schemaPageUrl, generateSchema } from "../utils/utils"

const BlogPost = ({ data, pageContext }) => {
  const lang = data?.PostDetails?.fmmCore?.languageCode
  const slug = data?.PostDetails?.fmmCore?.frontendSlug
  const copyrightMessage = stripTags(
    data?.FooterCopyright?.edges[0]?.node?.content
  )

  const SchemaTypes = data?.PostDetails?.blogSchemaCollection?.schemaTypes
  const AuthorName =
    data?.PostDetails?.blogSchemaCollection?.authorname ||
    data?.PostDetails?.author?.node?.name
  const PublishDate = data?.PostDetails?.date
  const ModifiedDate = data?.PostDetails?.modified
  const PageUrl = schemaPageUrl(lang, slug)
  const PageTitle = data?.PostDetails?.title
  const SeoDescription = data?.PostDetails?.fmmCore?.seoDescription
  //const SeoTitle = data?.PostDetails?.fmmCore?.seoTitle
  const FeaturedImageSrc =
    data?.PostDetails?.featuredImage?.node?.localFile?.childImageSharp?.fluid
      ?.src
  const SchemaImage = FeaturedImageSrc
    ? `https://findmymethod.org${FeaturedImageSrc}`
    : "https://fmm-admin.safe2choose.org/wp-content/uploads/2022/03/Home.png"
  const SchemaImageAlt = data?.PostDetails?.featuredImage?.node?.altText
  const BlogFaqsList = data?.PostDetails?.blogFaqSection?.faqsList
  
  const schemaMarkup = generateSchema({
    schemaTypes: SchemaTypes,
    pageTitle: PageTitle,
    seoDescription: SeoDescription,
    schemaImage: SchemaImage,
    authorName: AuthorName,
    publishDate: PublishDate,
    modifiedDate: ModifiedDate,
    pageUrl: PageUrl,
    schemaImageAlt: SchemaImageAlt,
    blogFaqsList: BlogFaqsList,
    pageThumbnail: FeaturedImageSrc
  })

  return (
    <Layout
      lang={lang}
      languages={data?.Languages?.edges}
      copyrightMessage={copyrightMessage}
      slug={slug}
    >
      <Seo
        title={data?.PostDetails?.fmmCore?.seoTitle || data?.PostDetails?.title}
        description={data?.PostDetails?.fmmCore?.seoDescription}
        lang={lang}
        jsonLd={schemaMarkup}
      />

      <Hero
        title={data?.PostDetails?.title}
        intro={data?.PostDetails?.excerpt}
        lang={lang}
        slug="blog-post"
        imageUrl={
          data?.PostDetails?.featuredImage?.node?.localFile?.childImageSharp
            ?.fluid?.src
        }
        imgStyle={{objectFit: 'cover'}}
        pageContext={pageContext}
        isBlogPost
      />

      <section className="blog-post-featured-image pb-0">
        <Container>
          <Row>
            <Col xs="12">
              <figure>
                <img
                  src={
                    data?.PostDetails?.featuredImage?.node?.localFile
                      ?.childImageSharp?.fluid?.src
                  }
                  alt={data?.PostDetails?.title}
                />
              </figure>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section">
        <Container>
          <Row>
            <Col xs="12" md="10" className="mx-auto">
              <section
                className="blog-post page-content"
                dangerouslySetInnerHTML={{
                  __html: data?.PostDetails?.content,
                }}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </Layout>
  )
}

export default BlogPost

export const query = graphql`
  query ($id: String!, $frontend_slug: String!, $language_code: String!) {
    PostDetails: wpPost(id: { eq: $id }) {
      slug
      title
      content
      date(formatString: "YYYY-MM-DD")
      modified(formatString: "YYYY-MM-DD")
      fmmCore {
        frontendSlug
        languageCode
        seoDescription
        seoTitle
      }
      blogSchemaCollection {
          schemaTypes
          authorname
      }
      blogFaqSection {
        faqsList {
          answer
          question
        }
      }
      author {
        node {
          name
        }
      }
      featuredImage {
        node {
          altText
          localFile {
            childImageSharp {
              fluid(maxWidth: 1900, maxHeight: 1300, quality: 100, fit: COVER) {
                ...GatsbyImageSharpFluid
                src
              }
            }
          }
        }
      }
    }

    Languages: allWpPost(
      filter: { fmmCore: { frontendSlug: { eq: $frontend_slug } } }
    ) {
      edges {
        node {
          id
          fmmCore {
            languageCode
            frontendSlug
          }
        }
      }
    }

    FooterCopyright: allWpGenericBlock(
      filter: {
        fmmCore: { languageCode: { eq: $language_code } }
        generic_block_data: { type: { eq: "FooterCopyright" } }
      }
    ) {
      edges {
        node {
          id
          title
          content
        }
      }
    }
  }
`
